import {Section} from 'constants/NavConstants';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import {getStore} from 'redux-stores/Store';
import {SearchParams} from 'search/SearchConstants';
import * as SearchUIReduxActions from 'search/SearchUIReduxActions';
import {asWorklistType} from 'worklists/WorklistConstants';
import {resolveItemInWorklistFilter} from 'worklists/WorklistUtil';

export enum WorklistUIActionType {
  UPDATE_SIDEPANEL_SELECTED_WORKLIST = 'UPDATE_SIDEPANEL_SELECTED_WORKLIST',
}

export interface UpdateSidepanelSelectedWorklistAction {
  type: WorklistUIActionType.UPDATE_SIDEPANEL_SELECTED_WORKLIST;
  worklistId: string | null;
}
export function updateSidepanelSelectedWorklist(
  worklistId: string | null
): UpdateSidepanelSelectedWorklistAction {
  return {
    type: WorklistUIActionType.UPDATE_SIDEPANEL_SELECTED_WORKLIST,
    worklistId,
  };
}

export function openWorklistListing(
  worklistSummary: {id: string; itemType: string},
  searchParams?: SearchParams
): void {
  const defaultSearchParams = resolveItemInWorklistFilter(
    worklistSummary.id,
    asWorklistType(worklistSummary.itemType),
    searchParams
  );
  getStore().dispatch(updateSidepanelSelectedWorklist(worklistSummary.id));
  getStore().dispatch(SidepanelReduxActions.openListing(Section.WORKLIST_ITEMS, defaultSearchParams));
}

export function returnToWorklistsSidepanel(): void {
  getStore().dispatch(updateSidepanelSelectedWorklist(null));
  SidepanelActions.openSection(Section.WORKLISTS);
  getStore().dispatch(SearchUIReduxActions.forceRefreshSearch(Section.WORKLISTS));
}

export type WorklistUIAction = UpdateSidepanelSelectedWorklistAction;

export function forceRefreshWorklistsListing(): void {
  getStore().dispatch(SearchUIReduxActions.forceRefreshSearch(Section.WORKLISTS));
}

export function forceRefreshWorklistItemsListing(): void {
  getStore().dispatch(SearchUIReduxActions.forceRefreshSearch(Section.WORKLIST_ITEMS));
}
